export default __webpack_public_path__ + "static/bg-tax--mobile-b8f3415257bc63e32e685a90dc6c9d81.webp";